import { CommonModule } from '@angular/common';
import { Component, computed, input, Signal } from '@angular/core';

import { DateTime } from 'luxon';

import { JOB_STATUS_LABELS, SHIFT_STATUS_LABELS } from '../../shared';
import { JOB_STATUSES, JobStatusType, SHIFT_STATUSES, ShiftStatusType } from '../../types';

@Component({
    selector: 'lib-status-chip',
    imports: [CommonModule],
    templateUrl: './status-chip.component.html',
    styleUrl: './status-chip.component.css'
})
export class StatusChipComponent {
    status = input<ShiftStatusType | JobStatusType | string | undefined | null>(undefined);
    type = input<'shift' | 'job' | null>(null);
    endDateTime = input<string | null>(null);

    /**
     * Compares the shift's end datetime to the current datetime.
     * A shift is considered completed if it is status 'accepted' and
     * the end datetime is in the past
     */
    isShiftCompleted: Signal<boolean> = computed(() => {
        const endDateTime = this.endDateTime();

        if (!endDateTime) return false;

        const shiftEndDateTime = DateTime.fromISO(endDateTime);
        const currentDateTime = DateTime.now();
        return shiftEndDateTime < currentDateTime;
    });

    label: Signal<string | null> = computed(() => {
        if (this.type() === 'shift') {
            if (this.isShiftCompleted() && this.status() === SHIFT_STATUSES.ACCEPTED) {
                console.log(SHIFT_STATUS_LABELS.completed);
                return SHIFT_STATUS_LABELS.completed;
            } else {
                return SHIFT_STATUS_LABELS[this.status() as ShiftStatusType] || this.status() || null;
            }
        } else if (this.type() === 'job') {
            return JOB_STATUS_LABELS[this.status() as JobStatusType] || this.status() || null;
        } else {
            return this.status() || null;
        }
    });

    color: Signal<string> = computed(() => {
        if (
            (this.type() === 'shift' && this.status() === SHIFT_STATUSES.ACCEPTED) ||
            this.status() === JOB_STATUSES.CONFIRMED ||
            this.status() === JOB_STATUSES.COMPLETED
        ) {
            return 'green';
        } else if (
            this.status() === SHIFT_STATUSES.PENDING ||
            (this.type() === 'job' && this.status() === JOB_STATUSES.ACCEPTED) ||
            this.status() === JOB_STATUSES.PENDING
        ) {
            return 'yellow';
        } else if (this.type() === 'shift' && this.status() === SHIFT_STATUSES.REJECTED) {
            return 'grey';
        } else if (
            this.status() === SHIFT_STATUSES.REJECTED ||
            this.status() === SHIFT_STATUSES.CALLED_OFF ||
            this.status() === SHIFT_STATUSES.CANCELLED ||
            this.status() === SHIFT_STATUSES.SHIFT_CANCELLED ||
            this.status() === JOB_STATUSES.CANCELLED ||
            this.status() === JOB_STATUSES.REJECTED
        ) {
            return 'red';
        } else {
            return '';
        }
    });
}
